module.exports = __webpack_public_path__ + "static/media/berry-frost2@3x.14e1eec5.png";